import React from "react"
import classnames from "classnames"
import { usePagination, DOTS } from "./usePagination"
import PropTypes from "prop-types"

const CustomPagination = props => {
  const {
    onPageChange,
    totalCount,
    siblingCount,
    currentPage,
    pageSize,
    className,
  } = props

  const paginationRange = usePagination({
    currentPage,
    totalCount,
    siblingCount,
    pageSize,
  })

  const onNext = () => {
    onPageChange(currentPage + 1)
  }

  const onPrevious = () => {
    onPageChange(currentPage - 1)
  }

  let lastPage =
    paginationRange?.length > 0 && paginationRange[paginationRange.length - 1]
  return (
    <ul
      className={classnames("pagination-container", { [className]: className })}
    >
      <li
        className={classnames("pagination-item", {
          disabled: currentPage === 1,
        })}
        tabIndex="0"
        onClick={onPrevious}
        role="button"
        aria-label="Previous"
      >
        <div>Previous</div>
      </li>
      {paginationRange?.map((pageNumber, index) => {
        if (pageNumber === DOTS) {
          return (
            <li key={index} className="pagination-item dots" role="button" aria-label="dots">
              &#8230;
            </li>
          )
        }

        return (
          <li
            key={index}
            className={classnames("pagination-item event_button_click", {
              selected: pageNumber === currentPage,
            })}
            data-action-detail={currentPage}
            tabIndex="0"
            onClick={() => onPageChange(pageNumber)}
            role="button"
            aria-label={pageNumber}
          >
            {pageNumber}
          </li>
        )
      })}
      <li
        className={classnames("pagination-item event_button_click", {
          disabled: currentPage === lastPage,
        })}
        data-action-detail={currentPage}
        tabIndex="0"
        onClick={onNext}
        role="button"
        aria-label="Next"
      >
        <div>Next</div>
      </li>
    </ul>
  )
}

CustomPagination.propTypes = {
  onPageChange: PropTypes.func,
  totalCount: PropTypes.number,
  siblingCount: PropTypes.number,
  currentPage: PropTypes.number,
  pageSize: PropTypes.number,
  className: PropTypes.string,
}

export default CustomPagination